package dev.iad.portfoliowebsite.models

data class Experience(
    val company: String,
    val position: String,
    val summary: String,
    val end: String,
    val start: String,
)
